import * as React from "react";

import { MedicalType } from "@teamprevent/common/healthSurveillance/models";
import { Grid, Header, Input, InputOnChangeData } from "semantic-ui-react";

import { AddBillingTask } from "../../../../tasks/components/billingTasks/addBillingTask";
import { TaskCategoryDropdown } from "../../../../tasks/components/TaskCategoryDropdown";

import { AddTasks } from "../../../../tasks/components/addTasks";

import { PartialOhCaseDetailModel } from "../../model";

import { AddFileNoteButton } from "./AddFileNoteButton";

interface CoreDetailsTaskActionsProps {
    customerId: string;
    ohCase: PartialOhCaseDetailModel;
    ohCaseMedicalTypes: MedicalType[];
    taskCategories: string[];
    setTaskCategories: React.Dispatch<React.SetStateAction<string[]>>;
    setTaskTypeSearch: (value: React.SetStateAction<string>) => void;
}

export function CoreDetailsTaskActions(props: CoreDetailsTaskActionsProps) {
    const { customerId, ohCase, ohCaseMedicalTypes, taskCategories, setTaskCategories, setTaskTypeSearch } = props;

    const onTaskTypeSearchChange = React.useCallback((_e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setTaskTypeSearch(data.value);
    }, [setTaskTypeSearch]);

    return (
        <>
            <Grid columns="equal" container>
                <Grid.Row>
                    <Grid.Column width="1">
                        <Header>
                            Tasks
                        </Header>
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                        <TaskCategoryDropdown onSelectionChanged={setTaskCategories} selectedTaskCategories={taskCategories} />
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                        Task Name
                        <Input icon={"search"} onChange={onTaskTypeSearchChange} fluid />
                    </Grid.Column>
                    <Grid.Column stretched verticalAlign="bottom" width="3">
                        <AddFileNoteButton customerId={customerId} ohCaseId={ohCase.id} />
                    </Grid.Column>
                    <Grid.Column stretched verticalAlign="bottom" width="3">
                        {ohCase?.tasks &&
                            <AddBillingTask
                                key={ohCase.tasks.length}
                                ohCaseId={ohCase.id}
                                customerId={customerId}
                            />
                        }
                    </Grid.Column>
                    <Grid.Column stretched verticalAlign="bottom" width="3">
                        {ohCase?.tasks &&
                            <AddTasks
                                key={ohCase.tasks.length}
                                ohCase={ohCase}
                                customerId={customerId}
                                medicalTypes={ohCaseMedicalTypes}
                                caseType={ohCase?.caseType}
                            />
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
}
